/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CityResponseDto
 */
export interface CityResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CityResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CityResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the CityResponseDto interface.
 */
export function instanceOfCityResponseDto(value: object): value is CityResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CityResponseDtoFromJSON(json: any): CityResponseDto {
    return CityResponseDtoFromJSONTyped(json, false);
}

export function CityResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CityResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CityResponseDtoToJSON(json: any): CityResponseDto {
    return CityResponseDtoToJSONTyped(json, false);
}

export function CityResponseDtoToJSONTyped(value?: CityResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

